import React, {FC, useRef, useEffect, useState, useCallback} from 'react'
import {shallowEqual, useSelector, connect, useDispatch, ConnectedProps} from 'react-redux'
import {LayoutSplashScreen} from '../../../../_metronic/layout/core'
import * as auth from './AuthRedux'
import {getUserByToken} from './AuthCRUD'
import {RootState} from '../../../../setup'
import {actions as workspaceActions, IWorkspaceState} from '../../../@reducer/WorkspaceRedux'
import {UserWorkspace} from '../models/UserModel'
import {CreateDynamicClass} from '../../../features'

const mapState = (state: RootState) => ({auth: state.auth})
const connector = connect(mapState, auth.actions)
type PropsFromRedux = ConnectedProps<typeof connector>

const updateFaviconAndTitle = (() => {
  let link: HTMLLinkElement | null = null;
  return (faviconUrl: string, newTitle: string) => {
    if (!link) {
      link = document.querySelector('link[rel~="icon"]') as HTMLLinkElement;
      if (!link) {
        link = document.createElement('link');
        link.rel = 'icon';
        document.head.appendChild(link);
      }
    }
    if (link.href !== faviconUrl) {
      link.href = faviconUrl;
    }
    if (document.title !== newTitle) {
      document.title = newTitle;
    }
  };
})();


const AuthInit: FC<PropsFromRedux> = (props) => {
  const didRequest = useRef(false)
  const dispatch = useDispatch()
  const [showSplashScreen, setShowSplashScreen] = useState<boolean>(true)
  const accessToken = useSelector<RootState>(({auth}) => auth.accessToken, shallowEqual)
  const {images: {favicon}, name, colors: {primary, secondary}} = useSelector<RootState>(({workspace}) => workspace, shallowEqual) as IWorkspaceState

  const transformUserWorkspaceToWorkspaceInterface = useCallback(
      (userWorkspace: UserWorkspace): IWorkspaceState => ({
        id: userWorkspace.id,
        name: userWorkspace.name || 'MyWebforce',
        colors: {
          primary: userWorkspace.color?.main || '#0094f3',
          secondary: userWorkspace.color?.second || '#e1006d',
          textColor: userWorkspace.color?.text || '#fff',
        },
        is_active: userWorkspace.is_active || 0,
        images: {
          favicon: userWorkspace.icon || '',
          logo: userWorkspace.logo || '',
        },
      }),
      []
  )

  useEffect(() => {
    const root = document.documentElement;

    // Set CSS variables for workspace colors
    root.style.setProperty('--primaryWorkspaceColor50', `${primary}50`);
    root.style.setProperty('--secondaryWorkspaceColor50', `${secondary}50`);
    root.style.setProperty('--primaryWorkspaceColor', `${primary}`);
    root.style.setProperty('--secondaryWorkspaceColor', `${secondary}`);
  }, [primary, secondary]);

  useEffect(() => {
    console.log('****************** AuthInit ******************')
    CreateDynamicClass(primary, secondary)
    const requestUser = async () => {
      try {
        if (!didRequest.current) {
          const user = await getUserByToken()
          dispatch(props.fulfillUser(user))

          if (user?.workspace) {
            const transformedWorkspace = transformUserWorkspaceToWorkspaceInterface(user.workspace);
            updateFaviconAndTitle(transformedWorkspace.images.favicon, transformedWorkspace.name)
            dispatch(workspaceActions.setWorkspace(transformedWorkspace))
          } else {
            updateFaviconAndTitle(favicon, name)
          }

        }
      } catch (error) {
        if (!didRequest.current) {
          dispatch(props.logout())
        }
      } finally {
        setShowSplashScreen(false)
      }

      return () => (didRequest.current = true)
    }

    if (accessToken) {
      requestUser()
    } else {
      updateFaviconAndTitle(favicon, name)
      dispatch(props.logout())
      setShowSplashScreen(false)
    }
    // eslint-disable-next-line
  }, [])

  return showSplashScreen ? <LayoutSplashScreen /> : <>{props.children}</>
}

export default connector(AuthInit)
